export default function () {
  return {
    theme: null,
  }
}
